import React from "react";
import { Rating } from "react-simple-star-rating";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { Swiper, SwiperSlide } from "swiper/react";
import L from "leaflet";
function ChangeMapView({ coords }) {
  const map = useMap();
  map.setView([coords[0], coords[1], map.getZoom()]);

  return null;
}
class MapCom extends React.Component {
  state = {
    markers: [],
    swiperChange: false,
    itemId: 0,
    loading: true,
    position: [],
  };

  pushGarageDetails(id) {
    localStorage.setItem("mechanic_id", id);

    this.props.props.history.push({
      pathname: "/multiVendor/categoryDetails",
    });
  }
  render() {
    var iconPerson;
    var Icoon;
    iconPerson = new L.Icon({
      iconUrl: require("../../public/public/assets/icons/locationInMap.svg"),
      iconRetinaUrl: require("../../public/public/assets/icons/locationInMap.svg"),
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(60, 75),
      className: "leaflet-div-icon newLeaflet-div-icon",
    });
    // }else{
    Icoon = new L.Icon({
      iconUrl: require("../../public/public/assets/icons/locationInMap.svg"),
      iconRetinaUrl: require("../../public/public/assets/icons/locationInMap.svg"),
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(60, 75),
      className: "leaflet-div-icon",
    });
    // }

    return (
      <>
        {this.props.garages[this.state.itemId] == undefined ? (
          <div className='mappp'>
            <MapContainer center={[38.075418, 46.270496]} zoom={13}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
              />
            </MapContainer>
          </div>
        ) : (
          <div className='mappp'>
            <MapContainer center={[38.075555274342, 46.271007137983]} zoom={13}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
              />
              {this.state.itemId !== null &&
                this.state.swiperChange === true && (
                  <ChangeMapView coords={this.state.position} />
                )}
              {this.props.garages.map((item, index) =>
                this.state?.itemId === index || this.state?.itemId === 0 ? (
                  <Marker position={this.state.position} icon={iconPerson}>
                    <Popup>
                      A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                  </Marker>
                ) : (
                  <Marker
                    position={[
                      this.props?.garages[index]?.latitude,
                      this.props?.garages[index]?.longitude,
                    ]}
                    icon={Icoon}>
                    <Popup>
                      A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                  </Marker>
                )
              )}
            </MapContainer>
            <div className='swiperMapTab'>
              <Swiper
                spaceBetween={70}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                onSwiper={(item) =>
                  this.setState({
                    position: [
                      this.props?.garages[item?.realIndex]?.latitude,
                      this.props?.garages[item?.realIndex]?.longitude,
                    ],
                    swiperChange: true,
                  })
                }
                onSlideChange={(item) =>
                  this.setState({
                    itemId: item?.realIndex,
                    position: [
                      this.props?.garages[item?.realIndex].latitude,
                      this.props?.garages[item?.realIndex].longitude,
                    ],
                    swiperChange: true,
                  })
                }>
                {this.props?.garages.map((item, index) => (
                  <SwiperSlide virtualIndex={index}>
                    <div
                      className='swiperSlideMulti'
                      onClick={() => this.pushGarageDetails(item.id)}>
                      {item.kachar_suggests && (
                        <span className='kachar_suggests'>
                          <img
                            src='/public/assets/icons/kachar01.svg'
                            alt='pic'
                          />
                        </span>
                      )}
                      <div className='images'>
                        <img src={`${item?.image}`} alt='عکس' />
                      </div>
                      <div className='swiperSlideMultiDetails'>
                        <span className='name'>{item?.name}</span>
                        <Rating ratingValue={item?.rate * 20} readonly={true} />
                        <div className='Servicestype'>
                          <img
                            src='/public/assets/icons/repair222.svg'
                            alt='pic'
                          />
                          <span className='ServicestypeA'>{`${
                            item?.type === "both"
                              ? "خدمات سیار و ثابت"
                              : item?.type === "static"
                              ? "خدمات ثابت"
                              : item?.type === "dynamic"
                              ? "خدمات سیار"
                              : ""
                          }`}</span>
                        </div>
                        <div className='Servicestype'>
                          <img
                            src='/public/assets/icons/Vector.svg'
                            alt='pic'
                          />
                          <span className='ServicestypeA'>
                            {item?.service !== null && item?.service?.title}
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
      </>
    );
  }
}
export default MapCom;
